module.exports = __webpack_public_path__ + "static/media/mobile.5f830768.png";